module.exports = __webpack_public_path__ + "media/src/assets/images/six-industries-44ca800ef5fab730fa0f164a5b5623e7.svg";